import ContentTitle from "../../../components/ui/ContentTitle";
import { Button, Tabs, TabsProps, message } from "antd";
import { useEffect, useState } from "react";
import { Colors } from "../../../constants/Colors";
import { useNavigate, useParams } from "react-router-dom";
import { apiCall } from "../../../utils/apiCall";
import {
  AdvisorDetailDataType,
  BasicType,
  AdvancedType,
  MembershipType,
  PhotoType,
} from "./types";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { Dispatch, SetStateAction } from "react";
import { useReactiveVar } from "@apollo/client";
import { __currentUser__ } from "../../../graphql/policies";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import { ServiceTypes } from "../../../types/types";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import BasicInformationTab from "./BasicInformationTab";
import PerformanceTab from "./PerformanceTab";
import MembershipTab from "./MembershipTab";
import "./AdvisorDetail.scss";

interface AdvisorDetailProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const AdvisorDetail = ({
  setSelectedService,
  setSelectSubItem,
}: AdvisorDetailProps) => {
  const [activeKey, setActiveKey] = useState("1");
  const [advisorData, setAdvisorData] = useState<AdvisorDetailDataType>();
  const [basicData, setBasicData] = useState<BasicType>();
  const [photoData, setPhotoData] = useState<PhotoType>();
  const [advanceData, setAdvanceData] = useState<AdvancedType>();
  const [membershipData, setMembershipData] = useState<MembershipType>();

  const currentUser = useReactiveVar(__currentUser__);
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 5,
    },
  });

  const header = {
    headers: {
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
  };

  const navigate = useNavigate();
  const { companyNumber } = useParams();

  const fetchData = async () => {
    if (companyNumber) {
      const data = await apiCall({
        method: "GET",
        header: header,
        endPoint:
          process.env.REACT_APP_SALES_ADMIN +
          `/advisors/admin/${companyNumber}`,
      });
      if (data) {
        setAdvisorData(data);
        setAdvanceData(data.advanced);
        setBasicData(data.basic);
        setPhotoData(data.photo);
        setMembershipData(data.membership);
      }
    }
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "기본정보",
      children: (
        <BasicInformationTab
          basicData={basicData}
          photoData={photoData}
          setBasicData={setBasicData}
          setPhotoData={setPhotoData}
        />
      ),
    },
    {
      key: "2",
      label: "인사 및 성과관리",
      children: (
        <PerformanceTab
          advanceData={advanceData}
          setAdvanceData={setAdvanceData}
        />
      ),
    },
    // {
    //   key: "3",
    //   label: "계좌정보",
    //   children: <></>,
    // },
    {
      key: "4",
      label: "회원여부",
      children: (
        <MembershipTab
          membershipData={membershipData}
          setMembershipData={setMembershipData}
        />
      ),
    },
  ];

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const onSubmit = async () => {
    const filteredBasicData = Object.fromEntries(
      Object.entries(basicData || {}).filter(([_, value]) => value !== "")
    );

    const data = await apiCall({
      method: "PATCH",
      header: header,
      endPoint:
        process.env.REACT_APP_SALES_ADMIN + `/advisors/admin/${companyNumber}`,
      payload: {
        photo: {
          fileName: photoData?.fileName || "aaa.jpg",
          base64File: photoData?.data || photoData?.base64File || "",
        },
        basic: filteredBasicData,
        advanced: advanceData,
        membership: membershipData,
      },
    });
    if (data.status !== "SUCCESS") {
      message.error(renderAntDMessageConfig(data.response.data.status));
      return;
    } else {
      message.success(
        renderAntDMessageConfig(
          `${companyNumber}의 정보가 성공적으로 저장되었습니다.`
        )
      );
      setTimeout(() => {
        navigate("/sales188/advisor-management");
      }, 2000);
    }
  };

  useEffect(() => {
    fetchData();
    setSelectedService(ServiceTypes.SALES_188);
    setSelectSubItem("시스템 관리");
  }, []);

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "System Management"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="advisorDetailWrapper">
      <ContentTitle
        title={`${basicData?.name} (${companyNumber})`}
        returnTitle={`${basicData?.name} (${companyNumber})`}
        onReturn={() => {
          navigate(-1);
        }}
      />
      <Tabs
        activeKey={activeKey}
        items={items}
        onChange={onChange}
        tabBarStyle={{
          paddingLeft: 24,
          backgroundColor: Colors.white,
          height: 50,
        }}
      />
      <div className="footer" style={{ backgroundColor: Colors.white }}>
        <Button
          className="w-28"
          size="large"
          onClick={() => {
            navigate(-1);
          }}
        >
          취소
        </Button>
        <Button
          className="ml-4 w-28"
          size="large"
          type="primary"
          htmlType="submit"
          onClick={onSubmit}
        >
          저장
        </Button>
      </div>
    </div>
  );
};

export default AdvisorDetail;
